import { Tooltip } from "@mui/material";

const MultipleWebpages = ({
  scrapedData,
  selected,
  handleSelect,
  loading,
  url,
  submitHandler,
}) => {
  const maxSelect = 10;
  const limitReached = selected.length >= maxSelect;

  return (
    <div className="flex items-center justify-cente">
      <div className="relative">
        <div className="mb-4 -mt-1">
          {limitReached ? (
            <div className="bg-[#fee9e7] border !border-[#ec221f] rounded px-4 py-3 text-sm flex items-center">
              <span>
                <b>You've selected 10/10 webpages.</b> To add another, please
                unselect one of your current URLs or{" "}
                <a
                  href="https://start.maybetech.com/talk_to_us"
                  target="_blank"
                  className="underline"
                  rel="noreferrer"
                >
                  contact us
                </a>{" "}
                to upgrade your account and increase your limit.
              </span>
            </div>
          ) : (
            <div className="bg-[#ebffee] border !border-[#009951] rounded px-4 py-3 text-sm">
              Select <span className="font-bold">up to 10</span> webpages to add
              to your knowledge base.{" "}
              <a
                href="https://start.maybetech.com/talk_to_us"
                target="_blank"
                className="underline font-medium"
                rel="noreferrer"
              >
                Talk to us to add more.
              </a>
            </div>
          )}
        </div>

        <div className="rounded-[3px] px-3 py-6 mb-4 border !border-[#d9d9d9]">
          <div className="text-gray-500 text-sm mb-3">
            Current Source:{" "}
            <span className="text-gray-700">
              {scrapedData?.urls?.length || 0} webpages
            </span>
          </div>
          <div className="flex items-center">
            <input
              className="bg-[#f5f5f5] border !border-[#d9d9d9] focus:!outline-0 rounded-lg p-3 w-full text-[#767676] text-sm"
              value={url}
              readOnly
            />
            <span className="absolute right-[29%]">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2667_14542)">
                  <path d="M1.2 8.28L0 12L3.72 10.8L1.2 8.28Z" fill="#757575" />
                  <path
                    d="M7.89746 1.56305L2.04272 7.41779L4.58827 9.96333L10.443 4.10859L7.89746 1.56305Z"
                    fill="#757575"
                  />
                  <path
                    d="M11.82 1.86L10.14 0.18C9.90001 -0.06 9.54001 -0.06 9.30001 0.18L8.76001 0.72L11.28 3.24L11.82 2.7C12.06 2.46 12.06 2.1 11.82 1.86Z"
                    fill="#757575"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2667_14542">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span className="ml-4 text-gray-400 text-xs text-nowrap">
              <span
                className={`font-semibold ${
                  selected?.length >= 10 ? "text-[#900b09]" : "text-[#009951]"
                }`}
              >
                {selected.length}/10{" "}
              </span>
              pages selected
            </span>
          </div>
        </div>

        <div className="border !border-[#d9d9d9] rounded-lg p-4 mb-6 max-h-64 overflow-y-auto">
          <div className="grid grid-cols-1 gap-4">
            {scrapedData?.urls?.map((page) => (
              <div
                key={page}
                className="flex items-center bg-white border !border-[#d9d9d9] rounded px-3 py-4 truncate"
              >
                <div className="relative h-5 w-5">
                  <input
                    type="checkbox"
                    className="peer absolute w-full h-full z-40 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border !border-[#d9d9d9]"
                    id="check-vertical-list-group"
                    checked={selected.includes(page)}
                    onChange={() => handleSelect(page)}
                    disabled={
                      !selected.includes(page) && selected.length >= maxSelect
                    }
                  />
                  <span className="absolute z-0 text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="#009951"
                      stroke="#009951"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </div>
                <Tooltip
                  title={page}
                  placement="top"
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "zIndex",
                          enabled: true,
                          phase: "write",
                          fn: ({ state }) => {
                            state.styles.popper.zIndex = 9999;
                          },
                        },
                      ],
                    },
                  }}
                  arrow={true}
                  sx={{ width: "100%", whiteSpace: "nowrap" }}
                >
                  <span className="ml-3 text-sm text-[#1e1e1e] max-w-[420px] truncate">
                    {page}
                  </span>
                </Tooltip>
              </div>
            ))}
          </div>
          {loading && <div className="spinner !w-10 !h-10 mt-5"></div>}
        </div>
        {/* Next button */}
        <button
          className={`w-full py-2 rounded text-lg font-medium ${
            selected.length > 0
              ? "bg-gray-900 text-white hover:bg-gray-800"
              : "bg-gray-200 text-gray-400 cursor-not-allowed"
          }`}
          disabled={selected.length === 0 || scrapedData.loading}
          onClick={submitHandler}
        >
          {scrapedData.loading ? "Wait..." : "Next"}
        </button>
      </div>
    </div>
  );
};

export default MultipleWebpages;
